import { History } from "history";
import * as React from "react";
import { Wrap } from "./styles";

import { connect } from "react-redux";
import { GlobalState } from "../../store/rootReducer";

import i18next from "i18next";
import { withTranslation, WithTranslation } from "react-i18next";

import { Utils } from "@zanichelli/myz-react-utils";
import { goToPage } from "../../../utils/tools";
import { S3_IMAGE_FOLDER } from "../../../constants/endpoint";

import Heading from "../../components/Heading";
import Content from "../../components/Content";
import ContentCheekToCheek from "../../components/ContentCheekToCheek";

type Props = {
  history: History;
  email?: string;
  isSubscribed: boolean;
} & WithTranslation;

class Feedback extends React.Component<Props> {
  componentDidMount() {
    const { email, history } = this.props;
    if (!email) {
      goToPage("/home", history);
    }
  }

  handleText(isSubscribed: boolean) {
    const text = isSubscribed
      ? i18next.t("newwotd.feedback.identification.description")
      : i18next.t("newwotd.feedback.subcription.description");
    return text;
  }

  renderLeftContent() {
    const { email, isSubscribed } = this.props;
    const contentText = Utils.trans(this.handleText(isSubscribed), {
      EMAIL: email ? email : "",
    });
    return (
      <div>
        <Heading
          title={i18next.t("newwotd.title")}
          subtitle={i18next.t("newwotd.feedback.subtitle")}
        />
        <Content>
          <div className="contentDescription">
            <p
              dangerouslySetInnerHTML={Utils.manageMarkupContent(contentText)}
            />
            <p
              dangerouslySetInnerHTML={Utils.manageMarkupContent(
                i18next.t("newwotd.feedback.contact"),
              )}
            />
          </div>
        </Content>
      </div>
    );
  }

  render(): JSX.Element {
    return (
      <Wrap>
        <ContentCheekToCheek>
          {this.renderLeftContent()}
          <img
            src={S3_IMAGE_FOLDER + "/MyZanichelli_registrazione02.png"}
            alt=""
          />
        </ContentCheekToCheek>
      </Wrap>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  const email = state.subscriptionemail && state.subscriptionemail.email;
  const isSubscribed = !!state.subscriptionemail.isSubscribed;

  return {
    email,
    isSubscribed,
  };
}

export default connect(mapStateToProps)(withTranslation()(Feedback));
